module.exports = __webpack_public_path__ + "static/media/pen-fancy.45f64684.svg";